<template>
  <section class="terms_condition_popup" @click="hide">
    <div class="text-content">
      <img :src='require("../../assets/images/close.svg")'  alt="" class="close-btn" />
      <div class="comingsoon-box"> 
        <img :src='require("../../assets/images/comming_soonimg.png")' alt="Coming Soon" />
      </div>
      <h2 class="top-text">{{$t('Astrology')}}</h2>
      <ul>
        <li>{{$t('job')}}</li>
        <li>{{$t('married')}}</li>
        <li>{{$t('children')}}</li>
        <li>{{$t('marriedLife')}}</li>
        <li>
          {{$t('talkAstrology')}}
        </li>
      </ul>
      <p class="bold-text">
        {{$t('comingsoon')}}
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: "AstrologyModel",
  methods: {
    hide() {
      this.$emit("handlehide");
    }
  }
};
</script>
